import { createRecipe } from './runtime';

const buttonConfig = {"name":"button","defaultVariants":{"size":"md","tone":"light","variant":"primary"},"variantMap":{"size":["lg","md","sm"],"tone":["dark","light"],"variant":["ghost","navbar","primary","secondary","sliderDark","sliderLight"]}}

export const button = /* @__PURE__ */ createRecipe(buttonConfig)